import {
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { AffiliateLink } from "Components/Affiliate/AffiliateLink";
import type { AffiliateUserRole } from "Types/types";
import { useGetAffiliateLink } from "Api/Queries/Lead/useGetAffiliateLink";
import { AffiliateActionButtons } from "Components/Affiliate/AffiliateActions/AffiliateActionButtons";
import { getMooneInfoUrl } from "Components/Affiliate/mooneInfoUrl";
import { Resources, useResource } from "Translations/Resources";
import { useState } from "react";

const RESOURCES = Resources.Components.Affiliate.AffiliateLinkWithActions;

type AffiliateLinkType = "registration" | "mooneInfo";

type Props = {
  invitedUserRole: AffiliateUserRole;
};

export const AffiliateLinkWithActions = ({ invitedUserRole }: Props) => {
  const { t } = useResource();
  const { data, isLoading } = useGetAffiliateLink(invitedUserRole);
  const [selectedLinkType, setSelectedLinkType] =
    useState<AffiliateLinkType>("registration");

  const mooneInfoUrl = data?.code
    ? getMooneInfoUrl(invitedUserRole, data.code)
    : undefined;

  const affiliateCodeUrl =
    selectedLinkType === "registration" ? data?.url : mooneInfoUrl;

  return (
    <Stack gap={[6, 8]} mt={8} mb={[4, 0]}>
      <Stack gap={2}>
        <Typography fontWeight={600}>
          {t(RESOURCES.LinkTypeToggle.Title)}
        </Typography>
        <ToggleButtonGroup
          value={selectedLinkType}
          exclusive
          fullWidth
          size="small"
          onChange={(_, value) => {
            if (value) {
              setSelectedLinkType(value);
            }
          }}
        >
          <ToggleButton value="registration">
            {t(RESOURCES.LinkTypeToggle.Registration)}
          </ToggleButton>
          <ToggleButton value="mooneInfo">
            {t(RESOURCES.LinkTypeToggle.MooneInfo)}
          </ToggleButton>
        </ToggleButtonGroup>
      </Stack>
      <AffiliateLink
        affiliateCodeUrl={affiliateCodeUrl}
        isLoading={isLoading}
      />
      <AffiliateActionButtons
        affiliateCodeUrl={affiliateCodeUrl}
        invitedUserRole={invitedUserRole}
      />
    </Stack>
  );
};
